import React, { createContext } from 'react'





export const messageContext = React.createContext(null)